'use client'

import { Switch } from '@sushiswap/ui'
import type { FC } from 'react'
import { useState } from 'react'

import type { SushiSwapChainId } from 'sushi/evm'
import { ConcentratedPositionsTable } from '~evm/pool/_ui/ConcentratedPositionsTable/concentrated-positions-table'

// TODO: Restore "Liquidity Vault" tab when Katana smart pools API is available.
// See docs/steer-api-response-shapes.md for the expected data shape.
// Previously this had a tabbed interface with V3 and Smart (Steer) tabs,
// using isSmartPoolChainId to conditionally show the Steer positions tab
// with a SteerSmartPositionsTable component.

export const PositionsTab: FC<{
  chainId: SushiSwapChainId
}> = ({ chainId }) => {
  const [hideClosedPositions, setHideClosedPositions] = useState(true)

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end mb-4">
        <div className="flex items-center gap-3 whitespace-nowrap">
          <span className="text-sm font-medium text-gray-600 dark:text-slate-400">
            Hide closed
          </span>
          <Switch
            checked={hideClosedPositions}
            onCheckedChange={() => setHideClosedPositions((prev) => !prev)}
          />
        </div>
      </div>
      <ConcentratedPositionsTable
        chainId={chainId}
        hideNewSmartPositionButton={true}
        hideNewPositionButton={true}
        hideClosedPositions={hideClosedPositions}
      />
    </div>
  )
}
